import React, {useEffect, useRef, useState} from "react";
import {Button, Card, Col, Form, Row, Select, Spin} from "antd";
import PropTypes from "prop-types";

import {runCommand} from "../../helpers/hardware";
import {messageType, showMessages} from "../../helpers/message";

const CarFunctions = ({hardwareID}) => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);

    const [loading, setLoading] = useState(false);

    const [form] = Form.useForm();

    const handleFinish = async (values) => {
        setLoading(true);
        const abortSignal = abortSignalRef.current;

        const action = values['Action'];

        try {

            await runCommand(hardwareID, action, abortSignal);

            showMessages('This action was successfully applied.', messageType.success);
            setLoading(false);
        } catch (error) {
            showMessages(error.message, messageType.error);
            setLoading(false);
        }
    };

    // Cleanup effect when component unmounts
    useEffect(() => {
        const abortController = abortControllerRef.current;
        return function abort() {
            abortController.abort();
        }
    }, []);

    return (
        <Spin spinning={loading}>
            <Card title="Vehicle Functions" className="details-card">
            <Form
                form={form}
                layout="vertical"
                name="vehicle-functions"
                onFinish={handleFinish}
                disabled={hardwareID === 0}
            >
                <Form.Item
                    name="Action"
                    label="Action"
                    rules={[{required: true}]}
                >
                    <Select className="select-in-form">
                        <Select.Option value="lock_and_disable">
                            Lock Doors and Disable Ignition
                        </Select.Option>
                        <Select.Option value="unlock_and_enable">
                            Unlock Doors and Enable Ignition
                        </Select.Option>
                        <Select.Option value="lock_doors">
                            Lock Doors
                        </Select.Option>
                        <Select.Option value="unlock_doors">
                            Unlock Doors
                        </Select.Option>
                        <Select.Option value="enable_ignition">
                            Enable Ignition
                        </Select.Option>
                        <Select.Option value="disable_ignition">
                            Disable Ignition
                        </Select.Option>
                        <Select.Option value="push_greenlist">
                            Send Green List
                        </Select.Option>
                        <Select.Option value="delete_reservations">
                            Delete Reservations
                        </Select.Option>
                        <Select.Option value="send_blessed">
                            Send Blessed Tokens
                        </Select.Option>
                        <Select.Option value="send_blacklisted">
                            Send Lost/Stolen Tokens
                        </Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Row justify="end">
                        <Col>
                            <Button type="primary" htmlType="submit">
                                Apply
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
            </Card>
        </Spin>
    );
};

CarFunctions.propTypes = {
    hardwareID: PropTypes.number.isRequired,
}

export default CarFunctions;
